<template>
    <scrollactive class="reportside md:self-stretch flex flex-grow justify-right w-full overflow-y-auto pt-16 lg:pt-0"
        :offset="100"
        :duration="800"
        :scroll-offset="1"
        :modify-url="true"
        @itemchanged="updateHash"
    >
        <ol start="0" class="reportside-items flex flex-col text-center md:text-left w-full">
            <li v-if="has_intro" class="introcount">
                <a class="scrollactive-item"
                    id="nav-introduction"
                    href="#introduction"
                    :aria-current="current_hash == 'introduction'"
                >
                    Introduction
                </a>
            </li>

            <li v-for="section in sections" class="count">
                <a class="scrollactive-item"
                    :href="'#' + section.nav"
                    :id="'nav-' + section.nav"
                    :aria-current="current_hash == section.nav"
                >
                    {{ section.name }}
                </a>
            </li>
        </ol>
    </scrollactive>
</template>

<script>
export default {
    props: {
        sections: {},
        has_intro: {},
    },

    data() {
        return {
            current_hash: this.getDefaultHash(),
        }
    },

    methods: {
        getDefaultHash() {
            return this.has_intro
                ? 'introduction'
                : this.sections[0].nav;
        },
        updateHash(event, currentItem, lastActiveItem) {
            this.current_hash = currentItem?.href.split("#")[1];
            history.pushState(null, null, currentItem ? currentItem.href : ' ');

            if (! event && this.current_hash) {
                // sidebar item was clicked, move focus to that section for accessibility reasons
                let el = document.getElementById(this.current_hash);

                if (el) {
                    this.$nextTick(() => {
                        el.focus();
                    })
                }
            }
        },
    },
}
</script>
